<form class="login-v2 login-v2-main" [style.position]="'relative'"
      [class.submitted]="submitted" (submit)="onSubmit()">
  <h1 class="tw-mb-[10px]">
    {{ 'login.title' | translate }}
  </h1>
  <a class="login-page-register-link"
     (click)="navigateToRegisterPage()">
    {{ 'sessions.new.register_url' | translate }}
  </a>
  <div class="form-group identifier-input-form-group">
    @if ((settingsObservable$ | async); as settings) {
      <label
          for="identifier-input">{{ 'login.v2.input_label_' + (settings.forced_identifier || '') | translate }}</label>
    }
    <input class="form-control tw-mt-[5px] tw-mb-[20px]"
           id="identifier-input"
           type="email"
           name="email"
           [formControl]="formControl"
           required>
    <div class="login-page-input-errors">
      @if (formErrors.error) {
        <app-input-errors translationKey="errors.login"
                          [errorsForField]="formErrors"/>
      }
    </div>
  </div>
  <button [disabled]="!formControl.valid" class="btn btn-raised btn-block btn-primary login-page-submit">
    <span>{{ 'generic.button_next' | translate }}</span>
  </button>
</form>
